import React from 'react';
import { Divider as DividerBase } from '@mantine/core';
export default function Divider() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <DividerBase
        align="center"
        color="#5E811E"
        size={'xl'}
        w={100}
      />
    </div>
  );
}
